import { parseError, URLS } from "@core/shared/utils";
import { errorToast, successToast } from "@design-system/components/toast";
import { useAction } from "@framework/shared/hooks";
import { trans } from "@mongez/localization";
import { userAtom } from "../../../framework/remix/config/atoms";

export function useUpdateProfileAction(onSave?: () => void) {
  const submit = useAction(URLS.account.edit);

  const editProfileSubmit = async ({ values, form }) => {
    const response = await submit(values);
    form.submitting(false);

    if (response.isOK) {
      successToast(trans("account.modifiedSuccessfully"));
      userAtom.update(response.data);
      onSave?.();
    } else {
      errorToast(parseError(response.error));
    }
  };

  return { editProfileSubmit };
}

export function useUpdatePasswordAction() {
  const submit = useAction(URLS.account.changePassword);

  const changePasswordSubmit = async ({ values, form }) => {
    const response = await submit(values);
    form.submitting(false);

    if (!response.error) {
      successToast(trans("account.changePasswordSuccessfully"));
      form.reset();
    } else {
      errorToast(parseError(response.error));
    }
  };

  return { changePasswordSubmit };
}
